import { IconProps } from "../../models/Icon";


export function DownloadIcon({ size = 20, color = "#000", opacity="1"}: IconProps) {
    return(
        <svg 
            width={size} 
            height={size} 
            viewBox="0 0 14 14" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
        >
            <path 
                d="M6.90144 9.32526C6.91313 9.3402 6.92807 9.35228 6.94513 9.36059C6.96218 9.3689 6.98091 9.37322 6.99988 9.37322C7.01885 9.37322 7.03757 9.3689 7.05463 9.36059C7.07168 9.35228 7.08662 9.3402 7.09832 9.32526L8.84832 7.11119C8.91238 7.02994 8.85457 6.90963 8.74988 6.90963H7.59207V1.62213C7.59207 1.55338 7.53582 1.49713 7.46707 1.49713H6.52957C6.46082 1.49713 6.40457 1.55338 6.40457 1.62213V6.90807H5.24988C5.14519 6.90807 5.08738 7.02838 5.15144 7.10963L6.90144 9.32526ZM12.7186 8.77838H11.7811C11.7124 8.77838 11.6561 8.83463 11.6561 8.90338V11.3096H2.34363V8.90338C2.34363 8.83463 2.28738 8.77838 2.21863 8.77838H1.28113C1.21238 8.77838 1.15613 8.83463 1.15613 8.90338V11.9971C1.15613 12.2737 1.37957 12.4971 1.65613 12.4971H12.3436C12.6202 12.4971 12.8436 12.2737 12.8436 11.9971V8.90338C12.8436 8.83463 12.7874 8.77838 12.7186 8.77838Z" 
                fill={color} 
                opacity={opacity}
            />
        </svg>
    )
}








